import { createSlice } from '@reduxjs/toolkit';

const aiInsightSlice = createSlice({
  name: 'aiInsight',
  initialState: {
    request: null,
  },
  reducers: {
    requestIssueInsight: {
      reducer(state, action) {
        state.request = action.payload;
      },
      prepare(entityType, entityId, kind) {
        return {
          payload: {
            entityType,
            entityId,
            kind,
            requestId: `insight-${Date.now()}-${Math.random()}`,
          },
        };
      },
    },
    clearIssueInsightRequest(state) {
      state.request = null;
    },
  },
});

export const { requestIssueInsight, clearIssueInsightRequest } = aiInsightSlice.actions;
export default aiInsightSlice.reducer;
